import { avatarGradient, initials } from '@racksavant/core';
import { mediaUrl } from '../lib/api';
import { moodStyle } from '../lib/mood';
import type { MoodId } from '@racksavant/core';
import styles from './ui.module.css';

export interface AvatarProps {
  name: string;
  src?: string | null;
  size?: number;
  /** Draws the user's signature mood as a ring. */
  mood?: MoodId | null;
  online?: boolean;
  className?: string;
}

export function Avatar({ name, src, size = 40, mood, online, className }: AvatarProps) {
  const [from, to] = avatarGradient(name || 'racksavant');
  const url = src ? mediaUrl(src) : '';

  return (
    <span
      className={[
        styles.avatar,
        mood ? styles.avatarRing : '',
        online === false ? styles.avatarOffline : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      style={{
        width: size,
        height: size,
        fontSize: Math.max(10, Math.round(size * 0.38)),
        background: `linear-gradient(135deg, ${from}, ${to})`,
        ...(mood ? moodStyle(mood) : {}),
      }}
      title={name}
    >
      {url ? (
        <img className={styles.avatarImage} src={url} alt="" loading="lazy" decoding="async" />
      ) : (
        <span aria-hidden="true">{initials(name)}</span>
      )}
    </span>
  );
}
